export class JwtHelper {
    public static parseBodyFromJwt(jwt: string): Object {
        const tokenParts = jwt.split('.');
        const rawPayload = atob(tokenParts[1]);

        return JSON.parse(rawPayload);
    }
}
